import { connect } from "react-redux";
import AuthPage from "../components/AuthPage";
import * as actionsAuth from "../../../_actions/auth";

const mapStateToProps = ({ Misc, Ticket }) => ({
    //Misc
    language: Misc.Settings.language,
    authToken: Misc.Auth.token,
    authTokenLoading: Misc.Auth.fetching.loading,
    authTokenFetchingError: Misc.Auth.fetching.err
});

const mapDispatchToProps = dispatch => ({
    getAuthToken: (ticketId, email) => {
        dispatch(actionsAuth.getAuthToken(ticketId, email));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthPage);
